import { useQuery } from '@tanstack/react-query';
import style from './Style.module.scss';
import { getChannelOptions } from '@/client/@tanstack/react-query.gen';
import { Box, Divider, Group, Text } from '@mantine/core';
import { translate } from '@/lib';
import dayjs from 'dayjs';
import { IconCalendar } from '@tabler/icons-react';

type AppearingInfo = {
  appearInId: number;
  appearLastId: number;
  appearInDate: string;
  appearLastDate: string;
}

export const AppearingInfo: React.FC<AppearingInfo> = ({
  appearInId,
  appearLastId,
  appearInDate,
  appearLastDate,
}) => {

  const { data: channelIn } = useQuery({
    ...getChannelOptions({
      path: {
        id: appearInId,
      }
    })
  })

  const { data: channelLast } = useQuery({
    ...getChannelOptions({
      path: {
        id: appearLastId,
      }
    })
  })
  if(!channelIn || !channelLast) return null;

  return (
    <Box className={style.appearingInfoContainer}>
      <Group gap="5"><IconCalendar color='green' size={16} /><Text fw={600} size="md"> {translate('ff.appearingInfo.firstAppeared', 'First Appeared')}</Text></Group>
      <Group>
        <Text>{translate(channelIn?.transify || '') || channelIn?.name}</Text>
        <Text>{dayjs(appearInDate).format('DD/MM/YYYY')}</Text>
      </Group>
      <Divider my="xs" />
      <Group gap="5"><IconCalendar color='orange' size={16} /><Text fw={600} size="md"> {translate('ff.appearingInfo.lastAppeared', 'First Appeared')}</Text></Group>
      <Group>
        <Text>{translate(channelLast?.transify || '') || channelIn?.name}</Text>
        <Text>{dayjs(appearLastDate).format('DD/MM/YYYY')}</Text>
      </Group>
    </Box>

  );
};